export const {
  keys: toKeys,
  values: toValues,
  entries: toEntries,
  assign,
} = Object
